export const isStaging =
  import.meta.env.MODE === 'development' ||
  window.location.href.includes('staging') ||
  window.location.href.includes('localhost')

export const isPreProd = window.location.href.includes('website-preprod')
